// extracted by mini-css-extract-plugin
module.exports = {"title":"_02eb8","header":"_02a20","wrapper":"_3ac62"};